import { createAsyncThunk } from '@reduxjs/toolkit';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import client from '../../../services/api-client';

export default createAsyncThunk('connectionManager/uploadVideoToTray', async (payload, { getState }) => {
  const { videoId, videoType, triggerUrl } = payload;

  const apiBaseUrl = selectApiBaseUrl(getState());

  const url = `${apiBaseUrl}/workflows/trigger/send-file`;
  await client(url, {
    body: {
      video_id: `${videoId}`,
      type: videoType,
      trigger_url: triggerUrl,
    },
  });
});
